<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="статус"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getCustomerStatus"
      :get-list="getItems"
      :can-create-catalog="canEditCustomerStatus()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <customer-status
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CustomerStatus from "./CustomerStatus.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "CustomerStatusSelect",
  components: { CustomerStatus, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getCustomerStatusesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getCustomerStatus(id) {
      const result = await this.getCustomerStatusById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditCustomerStatus() {
      return this.hasPermission([PERM.CATALOG_CUSTOMER_STATUS_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CustomerStatuses/CustomerStatusSelect.vue